import React, { Component } from "react";
import * as auth from "../../store/ducks/auth.duck";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import FullPageLoadingModal from "../../../components/ui/FullPageLoadingModal";
import { recordLogoutReason } from "../../utils/logoutReason";

class Logout extends Component {
  componentDidMount() {
    // Only a note on an earlier forced logout's reason if one is still
    // unsent, so this is the reason only when the user clicked Logout.
    recordLogoutReason("logout_page");
    this.props.logout();
  }

  render() {
    const { hasAuthToken } = this.props;

    return hasAuthToken ? <FullPageLoadingModal /> : <Redirect to="/auth" />;
  }
}

export default connect(
  ({ auth }) => ({ hasAuthToken: Boolean(auth.authToken) }),
  auth.actions
)(Logout);
